export type VisitEnd = 'manual' | 'timeout' | 'error';
